import React from 'react';
import { Button, Icon, Form, List } from 'tabler-react';
import toast from 'cogo-toast';
import i18n from '../../shared/i18n';

class ShareModal extends React.Component {
  handleCopy = () => {
    document.querySelector('[name="share-text"]').select();
    document.execCommand('copy');
  };

  handleCopyLink = () => {
    document.querySelector('[name="share-link"]').select();
    document.execCommand('copy');
    toast.success(i18n.t('dash-tip-copyok'));
  };

  render() {
    const { shareText, referLink } = this.props;
    return (
      <div className="malus-share">
        <Form.Group
          label={
            <Form.Label>
              {i18n.t('dash-aff-textcopy')}
              <Button
                color="secondary"
                size="sm"
                pill
                onClick={this.handleCopy}>
                <Icon name="copy" />
                {i18n.t('dash-btn-copy')}
              </Button>
            </Form.Label>
          }>
          <Form.Textarea
            rows={4}
            name="share-text"
            value={shareText}
            readOnly
          />
        </Form.Group>
        <Button.List className="malus-social-group" align="left">
          <Button
            social="facebook"
            RootComponent="a"
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              referLink,
            )}`}
            target="_blank">
            <span>{i18n.t('dash-prefix-shareto')} Facebook</span>
          </Button>
          <Button
            social="twitter"
            RootComponent="a"
            href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
              shareText,
            )}`}
            target="_blank">
            <span>{i18n.t('dash-prefix-shareto')} Twitter</span>
          </Button>
        </Button.List>
        <Form.Group label={i18n.t('dash-aff-link')}>
          <Form.InputGroup className="copy-input">
            <Form.Input name="share-link" readOnly value={referLink} />
            <Form.InputGroupAppend>
              <Button
                RootComponent="button"
                color="primary"
                onClick={this.handleCopyLink}>
                <Icon prefix="fe" name="copy" />
                {i18n.t('dash-btn-copy')}
              </Button>
            </Form.InputGroupAppend>
          </Form.InputGroup>
        </Form.Group>
        <Form.Group label={i18n.t('dash-aff-ruletitle')}>
          <List>
            <List.Item>
              {i18n.t('dash-aff-rule1')}
            </List.Item>
            <List.Item>
              {i18n.t('dash-aff-rule2')}
            </List.Item>
            <List.Item>
              {i18n.t('dash-aff-rule3')}
              <a href="/affiliate" target="_blank">
                {i18n.t('dash-aff-ruleaffbtn')}
              </a>
            </List.Item>
          </List>
        </Form.Group>
      </div>
    );
  }
}

export default ShareModal;
